import * as React from 'react';

import TabletNavbar, {
  TabletNavbarMenuItem,
  TabletNavbarProps,
} from '../../organisms/TabletNavbar';
import Clock from '../../atoms/Clock';
import Heading from '../../atoms/Heading';
import Image from '../../atoms/Image';

export interface Props<T extends TabletNavbarMenuItem = TabletNavbarMenuItem>
  extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  children: React.ReactNode;
  title?: string | React.ReactNode;
  menu: TabletNavbarProps<T>['menu'];
  hideClock?: boolean;
  fixed?: boolean;
  onItemClick?: (item: Omit<T, 'children' | 'icon'>) => void;
  footer?: React.ReactNode;
}

const TabletAppTemplate = <
  T extends TabletNavbarMenuItem = TabletNavbarMenuItem,
>({
  children,
  title = 'Quality24',
  menu,
  hideClock = false,
  fixed = false,
  onItemClick,
  footer,
  ...htmlElementProps
}: Props<T>) => (
  <div {...htmlElementProps}>
    <TabletNavbar
      menu={menu}
      fixed={fixed}
      onItemClick={onItemClick}
      footer={footer}
    >
      <div className="d-flex flex-justify-between flex-items-center">
        <Heading as="h3">{title}</Heading>
        {!hideClock && <Clock format="DD/MM/YYYY - HH:mm" />}
        <Image
          src="https://d9d5m694col3p.cloudfront.net/images/branding/logo_quality24_light_color_256px.png"
          alt="Logotipo Quality24"
        />
      </div>
    </TabletNavbar>
    <main
      style={{
        height: 'calc(100vh - 4.5rem)',
        paddingTop: fixed ? '4rem' : undefined,
      }}
    >
      {children}
    </main>
  </div>
);

export default TabletAppTemplate;
